import i18n from "i18next";
import { toast } from "sonner";
import { isNativeApp } from "../native/platform";

/*
 * 403 { code: "PLAN_LIMIT", feature } from any API call (docs/PLANS.md): one
 * clear message wherever the limit is hit — what ran out and where the plans
 * are — instead of each screen's generic «не удалось». Shown once at a time.
 */

type Lang = "ru" | "kg" | "en";
const T: Record<Lang, { title: string; text: (f: string) => string; action: string; site: string; f: Record<string, string> }> = {
  ru: {
    title: "Лимит вашего тарифа",
    text: (f) => `${f} — больше на вашем тарифе нельзя. Перейдите на тариф выше, ничего не потеряется.`,
    action: "Тарифы",
    site: "Тарифы — на сайте turaq.kg",
    f: { active_listings: "Активные объявления", agents: "Агенты в команде", complexes: "ЖК", import_rows_month: "Строки импорта в этом месяце", advanced_analytics: "Расширенная аналитика", crm_clients: "Клиенты и календарь", collections: "Подборки", owner_reports: "Отчёт собственнику", crm_leads: "Лиды в CRM", short_links: "Короткие ссылки", inventory: "Общая база объектов", team_analytics: "Аналитика сотрудников", listing_analytics: "Аналитика объектов", district_market: "Рынок района", internal_prices: "Внутренние цены" },
  },
  kg: {
    title: "Тарифиңиздин лимити",
    text: (f) => `${f} — тарифиңизде мындан көп болбойт. Жогорку тарифке өтүңүз, эч нерсе жоголбойт.`,
    action: "Тарифтер",
    site: "Тарифтер — turaq.kg сайтында",
    f: { active_listings: "Активдүү жарыялар", agents: "Командадагы агенттер", complexes: "ТЖК", import_rows_month: "Ушул айдагы импорт саптары", advanced_analytics: "Кеңейтилген аналитика", crm_clients: "Кардарлар жана календарь", collections: "Тандоолор", owner_reports: "Ээсине отчет", crm_leads: "CRMдеги лиддер", short_links: "Кыска шилтемелер", inventory: "Объекттердин жалпы базасы", team_analytics: "Кызматкерлердин аналитикасы", listing_analytics: "Объекттердин аналитикасы", district_market: "Райондун рыногу", internal_prices: "Ички баалар" },
  },
  en: {
    title: "Your plan's limit",
    text: (f) => `${f} — your plan doesn't allow more. Move to a higher plan, nothing is lost.`,
    action: "Plans",
    site: "Plans are on turaq.kg",
    f: { active_listings: "Active listings", agents: "Team agents", complexes: "Complexes", import_rows_month: "Import rows this month", advanced_analytics: "Advanced analytics", crm_clients: "Clients and calendar", collections: "Selections", owner_reports: "Owner report", crm_leads: "CRM leads", short_links: "Short links", inventory: "Shared object base", team_analytics: "Member analytics", listing_analytics: "Listing analytics", district_market: "District market", internal_prices: "Internal prices" },
  },
};

export function notifyPlanLimit(data: { code?: string; feature?: string } | undefined): boolean {
  if (data?.code !== "PLAN_LIMIT") return false;
  const l = i18n.language || "ru";
  const L = T[l.startsWith("kg") || l.startsWith("ky") ? "kg" : l.startsWith("en") ? "en" : "ru"];
  const feature = (data.feature && L.f[data.feature]) || L.title;
  const native = isNativeApp();
  toast.warning(L.title, {
    id: "plan-limit",
    description: native ? `${L.text(feature)} ${L.site}` : L.text(feature),
    duration: 10_000,
    ...(native ? {} : { action: { label: L.action, onClick: () => window.location.assign("/dashboard/tariffs") } }),
  });
  return true;
}
